module.exports = __webpack_public_path__ + "static/media/cert_4.f05cfd18.jpg";